import { EProgrammingStatus, Programming } from '../models/programming';

export interface ProgrammingTripStageClosure {
    key: string;
    label: string;
    plannedAtUtc?: string;
    actualAtUtc?: string;
    deviationMinutes?: number | null;
    dwellMinutes?: number | null;
}

export interface ProgrammingTripClosure {
    stages: ProgrammingTripStageClosure[];
    finalStatusLabel?: string | null;
    isCompletedTrip: boolean;
    finishedWithDelay: boolean;
    destinationDelayMinutes?: number | null;
    delayStageLabel?: string | null;
    intermediateDelayNotes: string[];
}

export function getTripClosureFromProgramming(
    programming: Programming
): ProgrammingTripClosure | undefined {
    return programming.tripClosure as ProgrammingTripClosure | undefined;
}

export function getTripClosureColumnLabel(programming: Programming): string {
    const closure = getTripClosureFromProgramming(programming);
    if (closure?.finalStatusLabel) return closure.finalStatusLabel;
    return '—';
}

export function isCompletedStatus(status: string | number): boolean {
    const n = typeof status === 'number' ? status : Number(status);
    return n === EProgrammingStatus.Completed || n === EProgrammingStatus.Finished;
}

export function formatDeviationMinutes(value?: number | null): string {
    if (value === null || value === undefined) return '—';
    if (value === 0) return '0';
    return value > 0 ? `+${value}` : String(value);
}
